import source from '../assets/source.json';

const poets = source.poets;

export function getById(id) {
    const poets = poets.filter(x => x.id === id)[0];
    return poets;
}

export function getAllPoets(id) {
    return poets;
}
